export default __webpack_public_path__ + "static/media/buffet_responsive.f8fa6186.png";